import { render, staticRenderFns } from "./instrucciones.vue?vue&type=template&id=6ec429e0&scoped=true"
import script from "./instrucciones.vue?vue&type=script&lang=js"
export * from "./instrucciones.vue?vue&type=script&lang=js"
import style0 from "./instrucciones.vue?vue&type=style&index=0&id=6ec429e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec429e0",
  null
  
)

export default component.exports